// import React, { useEffect, useState } from "react";

// const NetworkStatusNotifier = () => {
//   const [isOnline, setIsOnline] = useState(navigator.onLine);

//   useEffect(() => {
//     const handleOnline = () => setIsOnline(true);
//     const handleOffline = () => setIsOnline(false);

//     window.addEventListener("online", handleOnline);
//     window.addEventListener("offline", handleOffline);

//     return () => {
//       window.removeEventListener("online", handleOnline);
//       window.removeEventListener("offline", handleOffline);
//     };
//   }, []);

//   return (
//     <>
//       {!isOnline && (
//         <div className="fixed top-0 left-0 w-full bg-red-600 text-white text-center py-2 z-50">
//           🔌 You are offline. Please check your internet connection.
//         </div>
//       )}
//     </>
//   );
// };

// export default NetworkStatusNotifier;


import React, { useEffect, useState } from "react";

const NetworkStatusNotifier = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showBanner, setShowBanner] = useState(!navigator.onLine);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setMessage("✅ You are back online.");
      setShowBanner(true);

      // Hide after 3 seconds
      setTimeout(() => {
        setShowBanner(false);
      }, 3000);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setMessage("🔌 You are offline. Please check your internet connection.");
      setShowBanner(true);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return (
    <>
      {showBanner && (
        <div
          className={`fixed top-0 left-0 w-full text-white text-center py-2 z-50 transition-all duration-300 ${
            isOnline ? "bg-green-600" : "bg-red-600"
          }`}
        >
          {message}
        </div>
      )}
    </>
  );
};

export default NetworkStatusNotifier;
